<ul class="nav nav-tabs">
    <li role="presentation"
        routerLinkActive="active">
        <a data-cy="home" routerLink="home">Home</a>
    </li>
    <li *ngIf="isAuthenticated()"
        role="presentation"
        routerLinkActive="active">
        <a data-cy="address-search" routerLink="address-search">Address Search</a>
    </li>
    <li *ngIf="isAuthenticated()"
        role="presentation"
        routerLinkActive="active">
        <a data-cy="gps-search" routerLink="gps-search">GPS Search</a>
    </li>
    <li *ngIf="isInRole('jjr')"
        role="presentation"
        routerLinkActive="active">
        <a data-cy="unit-search" routerLink="unit-search">Unit Search</a>
    </li>
    <li *ngIf="isAuthenticated()"
        role="presentation"
        routerLinkActive="active">
        <a data-cy="video-requests" routerLink="video-requests">Video Requests</a>
    </li>
    <li *ngIf="showUsageReports()"
        role="presentation"
        routerLinkActive="active">
        <a data-cy="usage-reports" routerLink="usage-reports">Usage Reports</a>
    </li>
</ul>
